const allowedHosts = [
    "chantybikes.co.uk",
    "chantybikes.com",
    "www.chantybikes.com"
  ];

document.addEventListener("DOMContentLoaded", function () {

  // Run only on this domain
  // console.log('translate JS checking for:',window.location.hostname);
  
  // if (window.location.hostname !== "chantybikes.co.uk") return;

  // Stop script if hostname is not in allowed list
  if (!allowedHosts.includes(window.location.hostname)) return;

  // console.log('translate JS init for:',window.location.hostname);


  // Danish → English translations
  const translations = {
    // --- IMAGE TEXT SECTION ---
    "Bygget til børn. Godkendt af forældre.": "Built for kids. Approved by parents.",
    "Skabt til trygge cykelture og glade børn – med kvalitet, der kan mærkes hver eneste dag.":"Created for safe bike rides and happy children – with quality that can be felt every day.",
    "Skabt til at give trygge cykelture og glade børn – med kvalitet, der kan mærkes hver eneste dag.":
      "Created to give safe bike rides and happy children – with quality you can feel every single day.",
    "Du vil måske syntes om?": "You might also like?",
    "Se også disse populære modeller":"Also see these popular models",
    "Tilføj":"Add",
    "Kunder elsker også disse":"Customers also love these",
    "✅ Gratis fragt · 🚚 Levering 2–3 hverdage · 🔒 99 dages returret":"✅ Free shipping · 🚚 Delivery 2–3 business days · 🔒 99-day return policy",
    "GRATIS FRAGT PÅ ALLE VORES CYKLER":"FREE SHIPPING ON ALL OUR BIKES",

    // --- FEATURED MODELS ---
    "Chanty Cargo Kid": "Chanty Cargo Kid",
    "Den sejeste børneladcykel – bygget til leg, eventyr og kvalitetstid.Stabil, sikker og elsket af børn":
      "The coolest kids cargo bike – built for play, adventures, and quality time. Stable, safe, and loved by children",
    "Chanty Go Løbecykel": "Chanty Go Balance Bike",
    "Let og ergonomisk løbecykel med integreret LED-lys i både stel og forstyr. .":
      "Light and ergonomic balance bike with integrated LED lights in both frame and fork.",
    "Børnecykler": "Children's Bikes",
    "Klassiske børnecykler bygget til hverdagens ture og nye eventyr.Fra 12” til 26” – altid med fokus på tryghed, komfort og kvalitet.":
      "Classic children's bikes built for everyday rides and new adventures. From 12” to 26” – always focused on safety, comfort, and quality.",

    // --- ACCORDION TITLES + CONTENT ---
    "99 dages returret og e-mærket webshop": "99-day return policy and certified webshop",
    "Du handler trygt hos en dansk, godkendt webshop med udvidet returret – fordi tillid betyder alt for os.":
      "You shop safely at a Danish, certified webshop with an extended return policy – because trust means everything to us.",
    "Vi sælger kun børnecykler – og det gør os til det sikre valg - og gratis fragt":
      "We only sell children's bikes – and that makes us the safe choice – plus free shipping",
    "Som specialister i børnecykler ved vi præcis, hvad der skaber tryghed, stabilitet og kvalitet for børn i alle aldre.":
      "As specialists in children’s bikes, we know exactly what creates safety, stability, and quality for kids of all ages.",
    "EU-testede cykler og CE-godkendte": "EU-tested bikes and CE-certified",
    "Hver cykel lever op til europæiske sikkerhedsstandarder og er testet for stabilitet, balance og holdbarhed – så du kan føle dig tryg fra første tur.":
      "Every bike meets European safety standards and is tested for stability, balance, and durability – so you can feel safe from the first ride.",
    "En grønnere fremtid for vores børn": "A greener future for our children",
    "Vi planter et træ for hver cykel, du køber – fordi fremtiden tilhører vores børn.Hos Børnecyklerne.dk tænker vi på hele rejsen: miljøvenlig produktion, holdbare materialer og ansvar for naturen.":
      "We plant a tree for every bike you buy – because the future belongs to our children. At Børnecyklerne.dk, we think about the entire journey: eco-friendly production, durable materials, and responsibility for nature.",
      "Vi sælger kun børnecykler – og det gør os til det sikre valg":"We only sell children's bikes - and that makes us the safe choice.",

    // --- AGE GROUPS ---
    "2–4 år": "2–4 years",
    "3–5 år": "3–5 years",
    "4–6 år": "4–6 years",
    "5–7 år": "5–7 years",
    "6–8 år": "6–8 years",
    "7–11 år": "7–11 years",
    "10+ år": "10+ years",
    

    // --- PRODUCT TYPES ---
    "Drengecykel": "Boy's bike",
    "Pigecykel": "Girl's bike",
    "Løbecykler": "Balance Bikes",
    "Børneladcykler": "Kids Cargo Bikes",
    "Drengecykler": "Boys' Bikes",
    "Pigecykler": "Girls' Bikes",
    "Tilbehør": "Accessories",
    "Preordre": "Preorder",
    "Gaver": "Gifts",

    // --- OTHER TEXT ---
    "Start på løbecykel": "Start with balance bike",
    "De første pedalture": "First pedal rides",
    "Til skole og fritid": "For school and leisure",
    "Til skole og leg": "For school and play",
    "Fart og frihed": "Speed and freedom",
    "Komfort og styrke": "Comfort and strength",
    "Til større børn": "For older kids",
    "Livstidsgaranti på alle produkter": "Lifetime warranty on all products",
    "Gratis fragt": "Free shipping",
    "Levering på 2–4 hverdage": "Delivery in 2–4 weekdays",

    // --- COOKIE NOTICE ---
    "Cookies": "Cookies",
    "Websitet anvender \"cookies\", der er en tekstfil, som gemmes på din computer, mobil el. tilsvarende med det formål at genkende den, huske indstillinger, udføre statistik og målrette annoncer. Cookies kan ikke indeholde skadelig kode som f.eks. virus.":
      "The website uses \"cookies\", which are text files stored on your computer, mobile device, etc., for the purpose of recognizing it, remembering settings, performing statistics, and targeting ads. Cookies cannot contain harmful code such as viruses.",
    "Det er muligt at slette eller blokere for cookies.": "It is possible to delete or block cookies.",
    "Hvis du sletter eller blokerer cookies vil annoncer kunne blive mindre relevante for dig og optræde hyppigere. Du kan desuden risikere at websitet ikke fungerer optimalt samt at der er indhold, du ikke kan få adgang til.":
      "If you delete or block cookies, ads may become less relevant to you and appear more frequently. You may also risk the website not functioning optimally and that some content may be inaccessible.",

    // --- BUTTON TEXT ---
    "Se alle børneladcykler": "See all kids cargo bikes"
  };

  // Function to replace text only, keeping child elements like images intact
  function translateText(el) {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (translations[text]) {
          node.textContent = translations[text];
        }
      }
    });
  }

  // Apply translation to all relevant elements
  function translateAll() {
  document.querySelectorAll(
    '.shop-by-age__item-heading, \
     .shop-by-age__item-content, \
     .discover-categories__item-content strong, \
     .marquee-item.marquee-text, \
     .featured-models__item-heading, \
     .featured-models__item-content, \
     .image-text-invertible__inner-img-over-heading, \
     .image-text-invertible__inner-img-over-description, \
     .cc-accordion-item__title, \
     .cc-accordion-item__content, \
     .header-drawer__menu-image-title, \
     .submenu-items__item, \
     .submenu-items__back-button span, \
     .text-center, \
     .rte h1, \
     .rte p, \
     .featured-collection__view-all-button a, \
     .na-side-cart-upsell-product__atc, \
     .na-side-cart-upsell__header h3, \
     .na-side-cart-announcement__text p, \
     .na-side-cart-reward__message p'
  ).forEach(translateText);
}
setInterval(translateAll, 100);
 setInterval(() => {
    const headings = document.querySelectorAll('.shop-by-age__item-heading');

    if (headings.length > 1 && headings[1].textContent !== '3–5 years') {
      headings[1].textContent = '3–5 years';
    }
   
    
    const logo = document.querySelector('.mobile-menu-header__logo');
    if (logo) {
      logo.src = 'https://cdn.shopify.com/s/files/1/0595/3893/1847/files/chanty-logo.png?v=1762953603';
      logo.srcset = '';
      logo.classList.add('mobile-menu-header__logo_uk');
      // logo.style.setProperty('height', '90px', 'important');
      // logo.style.setProperty('width', 'auto', 'important');
      // clearInterval(logoInterval);
    }

 
    const firstItem = document.querySelector(
      '.menu-drawer-footer_row .menu-drawer-footer-item:first-child'
    );
    if (firstItem) {
      firstItem.style.display = 'none';
    }
  }, 1000);
});


// Function to translate elements
function translateCartText(node) {
  // if (window.location.hostname !== "chantybikes.co.uk") return;
  if (!allowedHosts.includes(window.location.hostname)) return;
  if (node.querySelectorAll) {
    // Translate cart header
    node.querySelectorAll('.cart-header__title').forEach(el => {
      if (el.innerHTML.includes('Kurv')) {
        el.innerHTML = el.innerHTML.replace('Kurv', 'Cart');
      }
    });

    // Translate empty cart message
    node.querySelectorAll('.na-side-cart-empty__message').forEach(el => {
      if (el.innerHTML.includes('Din kurv er tom')) {
        el.innerHTML = el.innerHTML.replace('Din kurv er tom', 'Your cart is empty');
      }
    });

    // Translate checkout button
    node.querySelectorAll('[data-na-cart-submit]').forEach(el => {
      if (el.innerHTML.includes('Fortsæt til sikker betaling')) {
        el.innerHTML = el.innerHTML.replace('Fortsæt til sikker betaling', 'Proceed to Secure Payment');
      }
    });

    // Translate savings text
    node.querySelectorAll('.na-side-cart-item__savings').forEach(el => {
      if (el.innerHTML.includes('Du sparer')) {
        el.innerHTML = el.innerHTML.replace('Du sparer', 'You save');
      }
    });

    // Translate upsell header
    node.querySelectorAll('#naUpsellHeaderText h3').forEach(el => {
      if (el.innerHTML.includes('Kunder elsker også disse')) {
        el.innerHTML = el.innerHTML.replace('Kunder elsker også disse', 'Customers also love these');
      }
    });

    // Translate discount label
    node.querySelectorAll('.na-side-cart-savings__discounts').forEach(el => {
      if (el.innerHTML.includes('Rabat')) {
        el.innerHTML = el.innerHTML.replace('Rabat', 'Discount');
      }
    });
  }
}

// Observe changes in the document body
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      translateCartText(node);
    });
  });
});

// Start observing the whole body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// Initial run to translate existing content
translateCartText(document.body);


